import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-mimic-confirmation-notification',
    templateUrl: './mimic-confirmation-notification.component.html',
    styleUrls: ['./mimic-confirmation-notification.component.scss'],
    standalone: false
})
export class MimicConfirmationNotificationComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            channelName: string;
            action: string;
            currentValue: string;
            newValue: string;
            units: string;
        },
        private dialogRef: MatDialogRef<MimicConfirmationNotificationComponent>,
    ) {
        if (!data.currentValue) data.currentValue = 'N/A';
    }

    cancel(): void {
        this.dialogRef.close();
    }

    confrim() {
        this.dialogRef.close(true);
    }
}
